var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _Button = _interopRequireDefault(require("./Universal/Basic/Button"));

var _Betting = _interopRequireDefault(require("./Universal/Betting"));

var _Voting = _interopRequireDefault(require("./Universal/Betting/Voting"));

var _Card = _interopRequireDefault(require("./Universal/Basic/Card"));

var _Title = _interopRequireDefault(require("./Universal/Basic/Title"));

var _Match = _interopRequireDefault(require("./Universal/Match"));

var _Standings = _interopRequireDefault(require("./Universal/Table/Standings"));

var _Liveticker = _interopRequireDefault(require("./Universal/Liveticker"));

var _Gameplan = _interopRequireDefault(require("./Universal/Gameplan"));

var _GameplanGroup = _interopRequireDefault(require("./Universal/Gameplan/GameplanGroup"));

var _FontelloIcon = _interopRequireDefault(require("./Universal/Basic/FontelloIcon"));

var _Form = _interopRequireDefault(require("./Universal/Form"));

var _Teaser = _interopRequireDefault(require("./Universal/Teaser"));

var _Favourites = _interopRequireDefault(require("./Universal/Favourites"));

var _FavouritesExpandable = _interopRequireDefault(require("./Universal/FavouritesExpandable"));

var _Squad = _interopRequireDefault(require("./Universal/Squad"));

var _Formation = _interopRequireDefault(require("./Universal/Formation"));

var _LabelValueRow = _interopRequireDefault(require("./Universal/Basic/LabelValueRow"));

var _Statistics = _interopRequireDefault(require("./Universal/Statistics"));

var _NewsList = _interopRequireWildcard(require("./Universal/News/NewsList"));

var _TopNews = _interopRequireDefault(require("./Universal/News/TopNews"));

var _Article = _interopRequireDefault(require("./Universal/Article"));

var _ErrorBoundary = _interopRequireDefault(require("./Universal/Basic/ErrorBoundary"));

var _config = _interopRequireDefault(require("../utilities/Fontello/config.json"));

var _RelatedMatch = _interopRequireDefault(require("./Universal/Match/RelatedMatch"));

var _Layouting = require("./Universal/Basic/Layouting");

var _Touchable = _interopRequireDefault(require("./Universal/Basic/Touchable"));

var _MatchComponents = require("./Universal/Match/MatchComponents");

var _index = require("./Universal/Basic/Logos/index");

var _i18n = _interopRequireDefault(require("../i18n"));

var _en = _interopRequireDefault(require("../i18n/locales/en"));

var _de = _interopRequireDefault(require("../i18n/locales/de"));

var _Ranking = _interopRequireDefault(require("./Universal/Ranking"));

var _RankingHeader = require("./Universal/Ranking/RankingHeader");

var _RankingRow = require("./Universal/Ranking/RankingRow");

var _Flatlist = _interopRequireDefault(require("./Web/Flatlist"));

var _FormationHalf = _interopRequireDefault(require("./Universal/Formation/FormationHalf"));

var _FormationBench = _interopRequireDefault(require("./Universal/Formation/FormationBench"));

var _FormationSubstitution = _interopRequireDefault(require("./Universal/Formation/FormationSubstitution"));

var _FormationTrainer = _interopRequireDefault(require("./Universal/Formation/FormationTrainer"));

var _FormationReferee = _interopRequireDefault(require("./Universal/Formation/FormationReferee"));

var _Transfers = _interopRequireDefault(require("./Universal/Transfers"));

var _Player = _interopRequireDefault(require("./Universal/Transfers/Player"));

var _PlayerName = _interopRequireDefault(require("./Universal/Basic/PlayerName"));

var _Body = _interopRequireDefault(require("./Universal/Article/Body"));

var _TabView = _interopRequireDefault(require("./Web/TabView"));

var _Table = _interopRequireDefault(require("./Universal/Table"));

var _Row = _interopRequireDefault(require("./Universal/Table/Row"));

var _Header = _interopRequireDefault(require("./Universal/Table/Header"));

var _TeamMatch = _interopRequireDefault(require("./Universal/Match/TeamMatch"));

var _Gallery = _interopRequireDefault(require("./Universal/Gallery"));

var _UniversalProvider = _interopRequireDefault(require("../utilities/UniversalProvider"));

var _DropDown = _interopRequireDefault(require("./Universal/Basic/DropDown"));

var _index2 = _interopRequireDefault(require("./Universal/ConferenceTicker/index"));

var _Header2 = _interopRequireDefault(require("./Universal/ConferenceTicker/Header"));

var _AssociatedMatchWithDate = _interopRequireDefault(require("./Universal/Match/AssociatedMatchWithDate"));

var _AssociatedMatchWithScores = _interopRequireDefault(require("./Universal/Match/AssociatedMatchWithScores"));

var _Loading = _interopRequireDefault(require("./Universal/Basic/Button/Loading"));

var _LoadingSpinner = _interopRequireDefault(require("./Universal/Basic/LoadingSpinner"));

var _VisibilitySensor = _interopRequireDefault(require("./Web/VisibilitySensor"));

var _Error = _interopRequireDefault(require("./Universal/Basic/DataFetching/Error"));

var _NoData = _interopRequireDefault(require("./Universal/Basic/DataFetching/NoData"));

var _RefreshButton = _interopRequireDefault(require("./Universal/RefreshButton"));

module.exports = {
  Article: _Article.default,
  ArticleBody: _Body.default,
  Betting: _Betting.default,
  Button: _Button.default,
  LoadingButton: _Loading.default,
  LoadingCircle: _LoadingSpinner.default,
  Card: _Card.default,
  ChildrenToRow: _Layouting.ChildrenToRow,
  CircleLogo: _index.CircleLogo,
  CountryLogo: _index.CountryLogo,
  CompetitionTitle: _MatchComponents.CompetitionTitle,
  ConferenceTicker: _index2.default,
  ConferenceTickerHeader: _Header2.default,
  ErrorBoundary: _ErrorBoundary.default,
  ErrorComponent: _Error.default,
  FanVoting: _Voting.default,
  Favourites: _Favourites.default,
  FavouritesExpandable: _FavouritesExpandable.default,
  FlatList: _Flatlist.default,
  FontelloIcon: _FontelloIcon.default,
  Form: _Form.default,
  Formation: _Formation.default,
  FormationHalf: _FormationHalf.default,
  FormationBench: _FormationBench.default,
  FormationSubstitution: _FormationSubstitution.default,
  FormationTrainer: _FormationTrainer.default,
  FormationReferee: _FormationReferee.default,
  Gallery: _Gallery.default,
  Gameplan: _Gameplan.default,
  GameplanGroup: _GameplanGroup.default,
  LabelValueRow: _LabelValueRow.default,
  Liveticker: _Liveticker.default,
  Logo: _index.Logo,
  Match: _Match.default,
  MatchMinute: _MatchComponents.LiveMinute,
  MatchScore: _MatchComponents.MatchScore,
  NewsItem: _NewsList.NewsItem,
  NewsList: _NewsList.default,
  Date: _NewsList.Date,
  NoDataComponent: _NoData.default,
  PlayerName: _PlayerName.default,
  PlayerTransfer: _Player.default,
  Ranking: _Ranking.default,
  RankingHeader: _RankingHeader.RankingHeader,
  RankingRow: _RankingRow.RankingRow,
  Touchable: _Touchable.default,
  CompetitionLogo: _index.CompetitionLogo,
  TeamLogo: _index.TeamLogo,
  translate: _i18n.default,
  DropDown: _DropDown.default,
  UniversalProvider: _UniversalProvider.default,
  en: _en.default,
  de: _de.default,
  RelatedMatch: _RelatedMatch.default,
  Squad: _Squad.default,
  Standings: _Standings.default,
  Statistics: _Statistics.default,
  TabView: _TabView.default,
  Table: _Table.default,
  TableHeader: _Header.default,
  TableRow: _Row.default,
  TeamMatch: _TeamMatch.default,
  Teaser: _Teaser.default,
  Title: _Title.default,
  TopNews: _TopNews.default,
  Transfer: _Transfers.default,
  fontelloConfig: _config.default,
  AssociatedMatchWithDate: _AssociatedMatchWithDate.default,
  AssociatedMatchWithScores: _AssociatedMatchWithScores.default,
  VisibilitySensor: _VisibilitySensor.default,
  RefreshButton: _RefreshButton.default
};